import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 1.5,
        delayChildren: 0.5
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 10
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1.2,
        ease: 'easeOut'
      }
    }
  };
  return <section className="relative min-h-screen w-full bg-gradient-to-b from-[#1B2838] to-[#15202B] px-6 py-20 md:py-32 flex flex-col items-center justify-center overflow-hidden" data-id="element-59">
      {/* Narrative Container */}
      <div className="max-w-2xl mx-auto w-full z-10" data-id="element-60">
        <motion.div className="space-y-8 text-center md:text-left" variants={containerVariants} initial="hidden" animate="visible" data-id="element-61">
          <motion.h1 variants={itemVariants} className="text-5xl md:text-7xl font-bold text-[#F5E6D0] tracking-tight font-sans mb-12 text-center" data-id="element-62">
            Son las 3:12 AM.
          </motion.h1>

          <div className="space-y-6 text-lg md:text-xl text-[#B8A99A] font-serif leading-relaxed max-w-prose mx-auto" data-id="element-63">
            <motion.p variants={itemVariants} data-id="element-64">Abres los ojos.</motion.p>

            <motion.p variants={itemVariants} data-id="element-65">
              No estás completamente despierta… pero tampoco estás dormida.
            </motion.p>

            <motion.p variants={itemVariants} data-id="element-66">
              Sientes calor. Y al mismo tiempo, tu mente hace lo que mejor sabe
              hacer: empieza a resolver.
            </motion.p>

            <motion.div variants={itemVariants} className="pl-4 border-l-2 border-[#E8614D]/30 italic text-[#F5E6D0]" data-id="element-67">
              <p className="mb-2" data-id="element-68">"Si no duermo, mañana voy a estar fatal."</p>
              <p className="mb-2" data-id="element-69">"Mañana tengo que rendir."</p>
              <p data-id="element-70">"¿Por qué me pasa esto?"</p>
            </motion.div>

            <motion.p variants={itemVariants} data-id="element-71">
              Y ahí es donde te ganas… o te pierdes.
            </motion.p>

            <motion.p variants={itemVariants} data-id="element-72">
              Porque el problema no es que te despiertes.
            </motion.p>

            <motion.p variants={itemVariants} className="text-[#F5E6D0] font-medium text-xl md:text-2xl" data-id="element-73">
              El problema es lo que haces en los primeros 90 segundos después de
              despertar.
            </motion.p>
          </div>
        </motion.div>

        {/* Product Reveal */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 12,
        duration: 1.5
      }} // Delays until after text reading
      className="mt-20 flex flex-col items-center text-center" data-id="element-74">
          <div className="relative w-full max-w-md mx-auto mb-10 group" data-id="element-75">
            <div className="absolute -inset-1 bg-[#E8614D] rounded-lg blur opacity-10 group-hover:opacity-20 transition duration-1000" data-id="element-76"></div>
            <img src="https://cdn.magicpatterns.com/uploads/wUdpVLC7UxHiJuGXFVwJ7h/Reinicio_de_las_3AM.png" alt="Reinicio de las 3:00 AM Kit en iPad" className="relative rounded-lg shadow-2xl shadow-black/50 w-full" data-id="element-77" />
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-[#F5E6D0] mb-4 font-sans" data-id="element-78">
            El protocolo 3×3 para volver a dormir{' '}
            <br className="hidden md:block" data-id="element-79" />
            <span className="text-[#E8614D]" data-id="element-80">(aunque tu mente se prenda).</span>
          </h2>

          <p className="text-[#B8A99A] mb-8 text-lg" data-id="element-81">
            Kit Express en español. PDF + Tarjeta imprimible + Tracker 7 noches.
          </p>

          <a href="#comprar" onClick={e => {
          e.preventDefault();
          document.getElementById('comprar')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="inline-flex items-center gap-2 bg-[#E8614D] hover:bg-[#D6523F] text-[#1B2838] font-bold py-4 px-8 rounded-full text-lg transition-all duration-300 transform hover:scale-105 shadow-lg shadow-[#E8614D]/20" data-id="element-82">
            Descarga el kit ahora <ArrowRight className="w-5 h-5" data-id="element-83" />
          </a>
        </motion.div>
      </div>

      {/* Ambient Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-[#E8614D] opacity-5 blur-[120px] pointer-events-none" data-id="element-84" />
    </section>;
}